<template>
    <WidgetSection
        ref="WidgetSection"
        :loaded="loaded"
        :loading="loading"
        :defaultToggle="defaultToggle"
        :unavailable="unavailable"
        loadingText="components.prospect_pageviews.loading_text"
        :cssClass="`content-type-9 ${cssClassWidgetSection}`"
        :paywall="paywallActive"
    >
        <template v-slot:section-title>
            <div class="title">
                {{ $t('components.prospect_owner.name')}}
            </div>
        </template>

        <template v-slot:section-content>
            <div class="row row-content">
                <div class="owners">
                    <div class="form-type-1">
                        <CustomSelectOwner
                            :modelValue="owner"
                            @update:modelValue="onChanged"
                            :includeOptionAll="false"
                            :includeOptionReset="true"
                            :showLabel="false"
                        />
                    </div>
                </div>
            </div>
        </template>
    </WidgetSection>
</template>

<script>
    import { mapState } from 'pinia';
    import { useProspectStore } from '@/stores/prospect';
    import { useUsersStore } from '@/stores/users';
    import { useAccountStore } from '@/stores/account';
    import CustomSelectOwner from '@/components/inputs/CustomSelectOwner';
    import WidgetSection from '@/components/sections/WidgetSection';
    import i18n from "@/plugins/i18n";
    import { useToastStore } from '@/stores/utils/toast';

    export default {
        name: "ProspectAssignment",
        components: {
            WidgetSection,
            CustomSelectOwner,
        },
        data() {
            return {
                loaded: false
            }
        },
        props: {
            defaultToggle: {
                type: Boolean,
                default: false
            },
            cssClassWidgetSection: {
                type: String,
                required: false
            },
            paywall: {
                type: Boolean,
                default: false
            },
        },
        computed: {
            ...mapState(useProspectStore, ['prospect']),
            ...mapState(useUsersStore, ['users', 'loading', 'getUsers']),
            owner() {
                return this.prospect.owner_id || '';
            },
            hasMultipleUsers() {
                return !this.loading && this.users && this.users.length > 1;
            },
            unavailable() {
                return (!this.prospect || !this.hasMultipleUsers) && this.loaded;
            },
            paywallActive() {
                return this.paywall && useAccountStore().paywall;
            },
        },
        methods: {
            onChanged(val) {
                const result = useProspectStore().updateOwner(val);

                if(result) {
                    useToastStore().addToast(i18n.global.t('toasts.success.owner_updated'), 'success');
                } else {
                    useToastStore().addToast(i18n.global.t('toasts.error.owner_not_updated'), 'error');
                }
            }
        },
        async mounted() {
            setTimeout(async () => {
                await this.getUsers();
                this.loaded = true;
            }, 300);
        }
    }
</script>